<template>
  <div class="container">
    <h1 class="title">Asignar cuentas al documento</h1>
    <h1 class="subtitle">
      <span class="title is-5">{{empresa.nombrec}}</span>
      <small class="title is-6">{{empresa.nit | textnumber()}}{{empresa.nit | dverif()}}</small>
      <small class="subtitle is-7">{{empresa.nombre}}</small>
    </h1>
    <hr />
    <div class="field is-grouped">
      <p class="control">
        <button class="button is-link" @click="asignar">
          <span class="icon">
            <span class="material-icons">hourglass_empty</span>
          </span>
          <span>Asignar</span>
        </button>
      </p>
      <p class="control">
        <button class="button" @click="cancelar">
          <span class="icon">
            <span class="material-icons">cancel</span>
          </span>
          <span>Cancelar</span>
        </button>
      </p>
      <p class="control is-expanded">
        <input class="input" type="text" placeholder="Buscar una cuenta" />
      </p>
      <p class="control">
        <button class="button is-light">
          <span class="icon">
            <span class="material-icons">search</span>
          </span>
          <span>Buscar</span>
        </button>
      </p>
    </div>
    <div class="table-container">
      <table class="table is-fullwidth">
        <thead>
          <tr>
            <th style="width: 71px;">Select</th>
            <th>Código</th>
            <th>Nombre</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(cuenta,index) in cuentasOrdenadas" :key="index">
            <td>
              <label class="checkbox">
                <input type="checkbox" v-model="cuenta.check" />
              </label>
            </td>
            <td class="fontMono">
              <strong>{{cuenta.codigo}}</strong>
            </td>
            <td>
              <input class="input" type="text" v-model="cuenta.renombrado" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import apiServices from "@/services/yungol-services";
export default {
  data() {
    return {
      cuentasOrdenadas: [],
      cuentasdcto: [],
    };
  },
  computed: {
    ...mapState(["empresa", "cuentas"]),
    infoempresa() {
      return this.empresa._id;
    },
  },
  methods: {
    cancelar() {
      this.$router.push({
        name: "configurations.documentedit",
        params: { id: this.$route.params.comprobanteid },
      });
    },
    async asignar() {
      try {
        const _this = this;
        const cuentaschecked = [];
        for (let index = 0; index < _this.cuentasOrdenadas.length; index++) {
          const cuenta = _this.cuentasOrdenadas[index];
          if (cuenta.check) {
            cuentaschecked.push(cuenta);
          }
        }
        const result = await apiServices.put(
          `/cuentasdctolote/${this.$route.params.comprobanteid}`,
          cuentaschecked
        );
        if (result.data) {
          this.$router.push({
            name: "configurations.documentedit",
            params: { id: this.$route.params.comprobanteid },
          });
          this.$store.dispatch("notify", {
            message: "Cuentas editadas con éxito.",
            type: "is-primary",
            position: "top-center",
          });
        }
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "No se pudo editar las cuentas.",
          type: "is-danger",
          position: "top-center",
        });
        console.log(err);
      }
    },
    async findcuentasdocumento() {
      try {
        const _this = this;
        this.cuentasOrdenadas = [];
        this.cuentasdcto = [];
        const result = await apiServices.get(
          `/cuentas/dcto/${this.$route.params.comprobanteid}`
        );
        if (result.data) {
          this.cuentasdcto = result.data;
          this.cuentasOrdenadas = [];
          for (let index = 0; index < _this.cuentas.length; index++) {
            const data = {
              _id: _this.cuentas[index]._id,
              renombrado: _this.cuentas[index].nombre,
              nombre: _this.cuentas[index].nombre,
              codigo: _this.cuentas[index].codigo,
            };
            _this.cuentasdcto.forEach(function (ctadcto) {
              if (ctadcto.cuenta.codigo === _this.cuentas[index].codigo) {
                data.check = true;
                data.renombrado = ctadcto.nombrep;
              }
            });
            _this.cuentasOrdenadas.push(data);
          }
          this.cuentasOrdenadas.sort(function (a, b) {
            if (a.codigo < b.codigo) {
              return -1;
            }
            if (a.codigo > b.codigo) {
              return 1;
            }
            return 0;
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
  created() {
    this.findcuentasdocumento();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/configurations/document/Cuentadocumento.vue